import { events } from '../core/events.js';
import { getItems } from '../game/inventory.js';
import { isGameInputBlocked } from '../input.js';

// Toggleable side panel showing the current inventory. Bound to the I key.
// Each cell shows a glyph icon tinted with the item's colour, its name, and
// the stack count (if > 1). Re-renders on inventory:changed.

let element = null;
let visible = false;

function build() {
  const el = document.createElement('div');
  el.className = 'inventory-panel hidden';
  el.innerHTML = `
    <div class="inventory-header">
      <span class="inventory-title">Cargo</span>
      <span class="inventory-count-label">empty</span>
    </div>
    <div class="inventory-grid"></div>
    <div class="inventory-footer"><kbd>I</kbd> close</div>
  `;
  (document.getElementById('right-stack') ?? document.body).appendChild(el);
  return el;
}

function colorToHex(n) {
  return '#' + n.toString(16).padStart(6, '0');
}

const MIN_SLOTS = 8;          // two rows' worth at 4 columns
const COLUMNS = 4;

function render() {
  if (!element) return;
  const grid = element.querySelector('.inventory-grid');
  const count = element.querySelector('.inventory-count-label');
  const items = getItems();
  const slotCount = Math.max(MIN_SLOTS, Math.ceil(items.length / COLUMNS) * COLUMNS);

  const cells = [];
  for (let i = 0; i < slotCount; i++) {
    const it = items[i];
    if (!it) {
      cells.push('<div class="inventory-slot empty"></div>');
      continue;
    }
    cells.push(`
      <div class="inventory-slot" style="--cell-color: ${colorToHex(it.color)}">
        <div class="inventory-icon">${it.icon ?? '◆'}</div>
        <div class="inventory-name">${it.name}</div>
        ${it.count > 1 ? `<div class="inventory-count">×${it.count}</div>` : ''}
      </div>
    `);
  }
  grid.innerHTML = cells.join('');

  const totalStacks = items.length;
  count.textContent = totalStacks === 0 ? 'empty' : `${totalStacks} / ${slotCount}`;
}

export function initInventoryUI() {
  element = build();
  events.on('inventory:changed', () => { if (visible) render(); });

  addEventListener('keydown', (e) => {
    if (isGameInputBlocked()) return;
    if (e.key.toLowerCase() !== 'i') return;
    visible = !visible;
    element.classList.toggle('hidden', !visible);
    if (visible) render();
  });
}
